// Copyright (c) 2022 GrayBits LLC

export async function waitForAll(parent){
  var images = (parent || document.body).querySelectorAll('img');
  
  for (var i = 0; i < images.length; i++){
    await waitForImage(images[i]);
  }
}

export function waitForImage(img){
  return new Promise((resolve, reject) => {
    if (img.complete){
      resolve('loaded');
    } else {
      img.addEventListener('load', (e) => resolve('loaded'));
    }
  });
}